<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseQuickSearch from "@/components/common/Filters/BaseQuickSearch.vue";
import {MenuConfig} from "@/enums/enums.js";
import {useRouter} from "vue-router";

const props = defineProps({
    permissions: {
        type: Array,
        required: true,
        default: () => []
    }
})

const router = useRouter();
const emit = defineEmits(['navigate'])
const { t } = useI18n()
const search = ref('')

const quickSearchEntity = {
    pages: {
        list: {
            filters: {
                quickSearch: {
                    searchBy: ['label']
                }
            }
        }
    }
}

const noop = async () => {}


const extractAllowed = (nodes, acc = []) => {
    for (const node of nodes) {
        if (node.allow && node.url) {
            acc.push(node.url)
        }
        if (node.menu?.length) {
            extractAllowed(node.menu, acc)
        }
    }
    return acc
}

const allowedUrls = computed(() =>
    extractAllowed(props.permissions)
)

const allowedMenu = computed(() =>
    MenuConfig.filter(item => allowedUrls.value.includes(item.url))
)

const filteredMenu = computed(() => {
    if (!search.value || !search.value.trim()) {
        return []
    }

    const term = search.value.toLowerCase()
    return allowedMenu.value.filter(item =>
        t(item.i18nKey).toLowerCase().includes(term)
    )
})

</script>

<template>
    <div class="menu-search">
        <BaseQuickSearch
            v-model="search"
            :entity="quickSearchEntity"
            :fetch-data="noop"
            :onKeyUp="false"
            :useTooltip="false"
            maxlength="30"
        />
        <v-list nav density="comfortable">
            <v-list-item
                v-for="item in filteredMenu.slice(0, 4)"
                :key="item.route"
                @click="router.push(item.route)"
                :title="t(item.i18nKey)"
            />
        </v-list>
    </div>
</template>

<style scoped>
.menu-search {
    width: 100%;
}
</style>
